import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from 'app/services/apiService';
import { showAlert } from 'app/utils';
import { setLoading, setLoadingFinished } from './loadingSlice';

const initialState = {
  chartData: [],
  unstructuredChartData: [],
  milestones: [],
  isMilestonesFetched: false,
  structuredTable: [],
  isStructuredTableFetched: false,
  unstructuredTable: [],
  isUnStructuredTableFetched: false,
  structuredLine: [],
  isStructuredLineFetched: false,
  unstructuredLine: [],
  isUnStructuredLineFetched: false,
  structuredPie: [],
  structuredPie2: [],
  isStructuredPieFetched2: false,
  isStructuredPieFetched: false,
  unstructuredPie: [],
  isUnStructuredPieFetched: false,
};

export const getStructuredTableData = createAsyncThunk('STable', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
      const response = await apiService.TableData('/structured');
      return response.data.structured;
  } catch (error) {
    showAlert('error', error.message);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const getUnStructuredTableData = createAsyncThunk('USTable', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
      const response = await apiService.TableData('/unstructured');
      return response.data.unstructured;
  } catch (error) {
    showAlert('error', error.message);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const getStructuredPieData = createAsyncThunk('SPie', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
      const response = await apiService.structuredChartData('/structured');
      return response.data.structured.dataClassLevelSpread;
  } catch (error) {
    showAlert('error', error.message);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const getStructuredPieData2 = createAsyncThunk('SPie2', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
      const response = await apiService.structuredChartData('/structured');
      return response.data.structured;
  } catch (error) {
    showAlert('error', error.message);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const getUnStructuredPieData = createAsyncThunk('USPie', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
      const response = await apiService.structuredChartData('/unstructured');
      return response.data.unstructured.dataClassLevelSpread;
      } catch (error) {
        showAlert('error', error.message);
      } finally {
        dispatch(setLoadingFinished());
      }
});

export const getStructuredLineData = createAsyncThunk('SLine', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
      const response = await apiService.lineChartData('/structured');
      return response.data.structured;
  } catch (error) {
    showAlert('error', error.message);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const getMilestones = createAsyncThunk('MileStones', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
    const response = await apiService.getMilestones();
    return response.milestones;
  } catch (error) {
    showAlert('error', error.message);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const getUnStructuredLineData = createAsyncThunk('USLine', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
      const response = await apiService.lineChartData('/unstructured');
      return response.data.unstructured;
  } catch (error) {
    showAlert('error', error.message);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const chartsSlice = createSlice({
  name: 'charts',
  initialState,

  reducers: {
    setMilestones(state, { payload }) {
      state.milestones = payload;
    },
    setPieChartData(state, { payload }) {
      state.structuredPie = payload;
    },
    setUnstructuredPieChartData(state, { payload }) {
      state.unstructuredPie = payload;
    },
    setStructuredLine(state, { payload }) {
      state.structuredLine = payload;
    },
    setUnstructuredLine(state, { payload }) {
      state.unstructuredLine = payload;
    },
    setChartData(state, { payload }) {
      state.chartData = payload;
    },
    setUnstructuredChartData(state, { payload }) {
      state.unstructuredChartData = payload;
    },
  },

  extraReducers(builder) {
    builder.addCase(getStructuredTableData.fulfilled, (state, { payload }) => {
      state.structuredTable = payload;
      state.isStructuredTableFetched = true;
    });
    builder.addCase(getUnStructuredTableData.fulfilled, (state, { payload }) => {
      state.unstructuredTable = payload;
      state.isUnStructuredTableFetched = true;
    });
    builder.addCase(getStructuredLineData.fulfilled, (state, { payload }) => {
      state.structuredLine = payload;
      state.isStructuredLineFetched = true;
    });
    builder.addCase(getUnStructuredLineData.fulfilled, (state, { payload }) => {
      state.unstructuredLine = payload;
      state.isUnStructuredLineFetched = true;
    });
    builder.addCase(getStructuredPieData.fulfilled, (state, { payload }) => {
      state.structuredPie = payload;
      state.isStructuredPieFetched = true;
    });

    builder.addCase(getStructuredPieData2.fulfilled, (state, { payload }) => {
      state.structuredPie2 = payload;
      state.isStructuredPieFetched2 = true;
    });
    builder.addCase(getUnStructuredPieData.fulfilled, (state, { payload }) => {
      state.unstructuredPie = payload;
      state.isUnStructuredPieFetched = true;
    });
    builder.addCase(getMilestones.fulfilled, (state, { payload }) => {
      state.milestones = payload;
      state.isMilestonesFetched = true;
    });
  },
});

export const {
  setMilestones,
  setunMilestones,
  setPieChartData,
  setUnstructuredPieChartData,
  setStructuredLine,
  setUnstructuredLine,
  setChartData,
  setUnstructuredChartData,
} = chartsSlice.actions;
export default chartsSlice.reducer;
